import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { API, deleteCall } from "../../../../config";
import Spin from "../../../common/Spin";

const ContractorDelete = ({
  contractorId,
  toggleDeleteModal,
  handleDelete,
  showDelete,
}) => {
  const [loading, setLoading] = useState(false);
  const handleContractorDelete = async () => {
    try {
      setLoading(true);
      const { data } = await deleteCall(
        `${API.CONTRACTOR_DELETE}/${contractorId}`
      );
      setLoading(false);
      toast.success(data?.message);
      handleDelete();
      toggleDeleteModal();
    } catch (e) {
      setLoading(false);
      return null;
    }
  };
  return (
    <Modal
      size="lg"
      show={showDelete}
      onHide={toggleDeleteModal}
      dialogClassName="modal-50w small-popup review-popup small-review"
      aria-labelledby="contained-modal-title-vcenter"
      className="business-section"
      centered
    >
      <Modal.Header className="mb-0" closeButton>
        Delete Contractor
      </Modal.Header>
      <Modal.Body>
        {loading && <Spin />}
        <div className="modal-body">
          Are you sure you want to delete this contractor?
        </div>
        <div className="modal-footer">
          <Button
            type="Button"
            className="btn btn-secondary"
            onClick={() => {
              toggleDeleteModal();
            }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className="btn btn-primary"
            data-dismiss="modal"
            onClick={() => {
              handleContractorDelete();
            }}
          >
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
    // <div
    //   className="modal fade"
    //   id="deleteContractor"
    //   tabindex="-1"
    //   role="dialog"
    //   aria-labelledby="exampleModalCenterTitle"
    //   aria-hidden="true"
    //   onClick={() => {
    //     toggleDeleteModal();
    //   }}
    // >
    //   <div className="modal-dialog modal-dialog-centered" role="document">
    //     <div className="modal-content">
    //       <div className="modal-header">
    //         <h5 className="modal-title" id="exampleModalLongTitle">
    //           Delete Contractor
    //         </h5>
    //         <button
    //           type="button"
    //           className="close"
    //           data-dismiss="modal"
    //           aria-label="Close"
    //         >
    //           <span aria-hidden="true">&times;</span>
    //         </button>
    //       </div>
    //       <div className="modal-body">
    //         Are you sure you want to delete this contractor?
    //       </div>
    //       <div className="modal-footer">
    //         <button
    //           type="button"
    //           className="btn btn-secondary"
    //           data-dismiss="modal"
    //         >
    //           Cancel
    //         </button>
    //         <button
    //           type="submit"
    //           className="btn btn-primary"
    //           data-dismiss="modal"
    //           onClick={() => {
    //             handleContractorDelete();
    //           }}
    //         >
    //           OK
    //         </button>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default ContractorDelete;
